import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import directives from './directives'

// ui
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
// rem px切换
import '@/utils/rem.js'
// 跑马灯无线轮播
import seamlessScroll from 'vue-seamless-scroll'
import VueRouter from 'vue-router'
Vue.use(VueRouter)

const originalPush = VueRouter.prototype.push
   VueRouter.prototype.push = function push(location) {
   return originalPush.call(this, location).catch(err => err)
}

// 第一步：在main.js引入emoji表情
import "font-awesome/css/font-awesome.css"; // 引入字体图标
import VEmojiPicker from "v-emoji-picker"; // 引入emoji图标
Vue.use(VEmojiPicker);

Vue.config.productionTip = false
Vue.use(ElementUI);
Vue.use(seamlessScroll)
Vue.use(directives)


new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
